import {Component} from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Document from 'part11/components/Document/Document';
import { loadDocument, loadDocumentHistory } from 'part11/actions/documents';
import lodash from 'lodash';
export class DocumentView extends Component {

    loadFileMetadata() {
        const historyDateRange = {
            start: moment().startOf('day').toDate(),
            end: moment().endOf('day').toDate()
        };
        const { documentId, binderId } = this.props;
        this.props.loadDocument(documentId, { dateRange: historyDateRange, binderId });
    }

    componentDidMount() {
        this.loadFileMetadata();
    }

    render() {
        const { binderId, documentId, loadDocumentHistory } = this.props;

        return <Document binderId={binderId}
            documentId={documentId}
            loadDocumentHistory={loadDocumentHistory} />;
    }
}

export default connect((state, props) => {
    let binderId = props.params.id || props.location.query.binderId;
    const documentId = props.params.documentId;
    
    const studyBinderId = lodash.get(state, 'study.binder.id');
    if (studyBinderId) {
        binderId = studyBinderId;
    }

    return {
        binderId,
        documentId,
    };
}, {
    loadDocument,
    loadDocumentHistory
})(DocumentView);